import { Play } from "lucide-react";
import { GALLERY } from "../../lib/constants";

// Bento spans for 10 items
const spans = [
  "md:col-span-2 md:row-span-2", // 0: featured video
  "",
  "",
  "md:col-span-2",
  "",
  "",
  "md:row-span-2",
  "",
  "",
  "md:col-span-2",
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#0B0B0B] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-[#FACC15] font-semibold mb-4">
            Gallery
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-semibold text-white">
            A peek inside.
          </h2>
          <p className="mt-4 text-white/50 text-base leading-relaxed">
            Calm, clean, and purpose-built spaces. The kind of place where deep
            work happens.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {GALLERY.map((item, i) => {
            const isVideo = item.type === "video";
            return (
              <div
                key={i}
                data-testid={`gallery-item-${i}`}
                className={`relative overflow-hidden bg-[#1A1A1A] rounded-sm group ${spans[i] || ""}`}
              >
                {isVideo ? (
                  <>
                    <video
                      src={item.src}
                      autoPlay
                      loop
                      muted
                      playsInline
                      preload="metadata"
                      aria-label={`Inside Justudy Library Noida — video tour ${i + 1}`}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute top-3 right-3 bg-[#0F0F0F]/85 backdrop-blur-sm border border-[#FACC15]/40 text-[#FACC15] text-[10px] uppercase tracking-[0.2em] font-semibold px-2 py-1 rounded-sm flex items-center gap-1">
                      <Play className="w-3 h-3 fill-[#FACC15]" /> Live
                    </div>
                  </>
                ) : (
                  <img
                    src={item.src}
                    alt={
                      i === 1
                        ? "Saraswati statue at Justudy Library Sector 22 Noida — silent study space"
                        : i === 2
                        ? "Justudy Library Sector 26 Noida entrance — best reading room near me"
                        : i === 3
                        ? "Reserved study desks with pinboards inside Justudy Library Noida"
                        : i === 4
                        ? "Spacious AC study hall — Justudy Library co-working space Noida"
                        : i === 5
                        ? "Individual study cubicle with personal pinboard — library in Sector 22 Noida"
                        : i === 7
                        ? "Student studying with laptop at Justudy Library — co-working space Noida"
                        : i === 8
                        ? "Books on study desk at Justudy Library — reading room in Sector 26 Noida"
                        : `Justudy Library Noida interior ${i + 1}`
                    }
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
